export default "__VITE_ASSET__pOYZ6qNr__"